import React from 'react';
import { I18n } from '@aws-amplify/core';

import { Organization } from './Organization';
import { Company } from './Company';
import { Sector } from './Sector';
import { Line } from './Line';
import { Workstation } from './Workstation';
import { UploadDate } from './UploadDate';
import { Fields, FiltersDrawer } from './styles';

const DRAWER_WIDTH = 568;
const FOOTER_GUTTER: [number, number] = [16, 16];

interface FilterDrawerProps {
	open?: boolean;
	onClose: () => void;
	onClear: () => void;
	onSubmit: () => void;
}

export function FilterDrawer({ open = false, onClose, onClear, onSubmit }: Readonly<FilterDrawerProps>): JSX.Element {
	return (
		<FiltersDrawer
			open={open}
			width={DRAWER_WIDTH}
			gutter={FOOTER_GUTTER}
			title={I18n.get('Filters')}
			onClose={onClose}
			onClear={onClear}
			onSubmit={onSubmit}
		>
			<Fields>
				<Organization />
				<Company />
				<Sector />
				<Line />
				<Workstation />
				<UploadDate />
			</Fields>
		</FiltersDrawer>
	);
}
